<template>
  <component :is="tag" class="_color_subtle" :class="linkStyle" rel="noopener noreferrer" target="_blank" :href="url">
    <span class="emd-status-tag eu-flex eu-no-margin eu-align-items_center" :class="[order, statusStyle]">
      <emd-status-icon v-if="status !== ''" class="eu-mr_1 eu-ml_1"/>
      {{ label }}
    </span>
  </component>
</template>

<script>
import { statusClass } from '../../../../filters'
import EmdStatusIcon from './childrenComponents/EmdStatusIcon.vue'

export default {
  components: { EmdStatusIcon },
  name: 'EmdStatusTag',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Status'
    },
    tag: {
      type: String,
      required: false,
      default: 'a'
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    invert: {
      type: Boolean,
      required: false,
      default: false
    },
    status: {
      type: String,
      required: false,
      default: '',
      validator: function (value) {
        return ['success', 'warning', 'danger', 'info', 'none', 'critical', 'major', 'minor', 'maintenance', ''].indexOf(value) !== -1
      }
    }
  },
  computed: {
    statusStyle () {
      return statusClass(this.status)
    },
    order () {
      return {
        'eu-justify_end': this.invert,
        'eu-row_reverse': this.invert
      }
    },
    linkStyle () {
      return {
        'emd-link': this.tag === 'a'
      }
    }
  }
}
</script>
